import { Injectable } from '@angular/core';
import { AppTenantDetail } from '@models/data/tenants/AppTenantDetail';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantHttpService } from '@services/http/tenant/tenant-http.service';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private selectedTenantSubject: BehaviorSubject<AppTenantDetail>;
  public selectedTenant: Observable<AppTenantDetail>;

  private loadingSelectedTenantSubject$: BehaviorSubject<boolean>;
  public loadingSelectedTenant$: Observable<boolean>;

  private currTenantsSubject: BehaviorSubject<AppTenantDetail[]>;
  public currTenants: Observable<AppTenantDetail[]>;

  private loadingCurrTenantsSubject$: BehaviorSubject<boolean>;
  public loadingCurrTenants$: Observable<boolean>;

  tenantLSKey = 'selectedTenant';

  constructor(private tenantHttpService: TenantHttpService) {
    this.selectedTenantSubject = new BehaviorSubject<AppTenantDetail>(null);
    this.selectedTenant = this.selectedTenantSubject.asObservable();

    this.currTenantsSubject = new BehaviorSubject<AppTenantDetail[]>(null);
    this.currTenants = this.currTenantsSubject.asObservable();

    this.loadingSelectedTenantSubject$ = new BehaviorSubject<boolean>(true);
    this.loadingSelectedTenant$ =
      this.loadingSelectedTenantSubject$.asObservable();

    this.loadingCurrTenantsSubject$ = new BehaviorSubject<boolean>(false);
    this.loadingCurrTenants$ = this.loadingCurrTenantsSubject$.asObservable();
  }

  /**
   * Returns the current subject value of selectedTenantSubject
   */
  public get selectedTenantValue(): AppTenantDetail {
    const selectedTenant = this.selectedTenantSubject.getValue();
    return selectedTenant ? selectedTenant : null;
  }

  public get currTenantsValue(): AppTenantDetail[] {
    const currTenants = this.currTenantsSubject.getValue();
    return currTenants && currTenants.length > 0 ? currTenants : null;
  }

  // public set currTenantsValue(content: AppTenantDetail []) {
  //   this.currTenantsSubject.next(content);
  // }

  // async listSpecificPersonAsync(fitMedProfileId: string): Promise<AppTenantDetail[]> {
  //   return this.tenantHttpService.listSpecificPersonAsync(fitMedProfileId);
  // }

  public init(): void {
    if (!this.currTenantsValue) {
      this.getSetTenants();
    }
  }

  public clear(): void {
    this.selectedTenantSubject.next(null);
    this.currTenantsSubject.next([]);
    this.storeLsSelectedTenant();
  }

  /**
   * Will get or set the default selected tenant based on the tenants available
   * (lists tenants and selects the first one)
   * @private
   */
  public getSetSelectedTenant(): void {
    this.loadingSelectedTenantSubject$.next(true);
    // Looking for localStorage value before querying the database for a default value
    const selectedTenantLs = this.getSelectedTenantLs;
    if (selectedTenantLs) {
      this.selectedTenantSubject.next(selectedTenantLs);
      this.loadingSelectedTenantSubject$.next(false);
      return;
    }

    this.setDefaultTenant();
  }

  /**
   * Retrieving all the tenants the users FMP has access to and setting the default to the first one in the list
   * @private
   */
  private setDefaultTenant(): void {
    if (!this.currTenantsValue) {
      return;
    }
    this.selectTenant(this.currTenantsValue[0]);
    this.loadingSelectedTenantSubject$.next(false);
  }

  /**
   * Queries and sets the current tenants
   */
  public getSetTenants(): void {
    // this.loadingCurrTenantsSubject$.next(true);
    // const practitionerFMP: FitMedProfile = this.appAuthService.currentUserValue.practitionerFitMedProfile;

    // this.tenantHttpService
    //   .getByFitMedProfileId(null)
    //   .then((tenants: AppTenantDetail[]) => {
    //     const tenantsExist = tenants && tenants.length > 0;
    //     if (tenantsExist) {
    //       this.currTenantsSubject.next(tenants);
    //
    //       this.getSetSelectedTenant();
    //     }
    //     this.loadingCurrTenantsSubject$.next(false);
    //     this.loadingSelectedTenantSubject$.next(false);
    //   });
  }

  /**
   * Selects a tenant based on the AppTenantDetail object passed in the params and stores it in localStorage
   * @param tenant
   */
  public selectTenant(tenant: AppTenantDetail): void {
    this.loadingSelectedTenantSubject$.next(true);

    this.storeLsSelectedTenant();
    this.selectedTenantSubject.next(tenant);

    // TODO: find a better way to do this
    setTimeout(() => {
      this.loadingSelectedTenantSubject$.next(false);
    }, 200);
  }

  // listAllTenants(fmpId: string): Promise<AppTenantDetail[]> {
  //   return this.tenantBlService.listAllTenants(fmpId);
  // }

  /* region Local Storage Tenancy Handling */
  /**
   * Returns the selectedTenant value from localStorage, null if there isn't one in there
   */
  private get getSelectedTenantLs(): AppTenantDetail {
    const val = localStorage.getItem(this.tenantLSKey);
    return val ? JSON.parse(val) : null;
  }

  /**
   * Sets a given LocalStorageTenantDetails object in localStorage
   * @private
   */
  private storeLsSelectedTenant(): void {
    const selectedTenant = this.selectedTenantValue;
    localStorage.setItem(this.tenantLSKey, JSON.stringify(selectedTenant));
  }

  /* endregion */
}
